export default "__VITE_ASSET__CwKlQlJv__"